<template>
  <div class="label__search_container">
    <label class="label_input_search">{{ label }}</label>
    <div>
      <div class="custom-select">
        <div class="selected" :class="{ open: open, notSelectedBeforeBlur: notSelectedBeforeBlur }">
          <span v-if="!open && !textToShow" class="custom-select-placeholder">{{ placeholder }}</span>
          <span v-if="!open">{{ textToShow }}</span>
          <input v-else ref="myInput" type="text" class="input_search" v-model.trim="textToFind">
          <RingLoader v-if="isLoading" />
        </div>
        <div class="items" :class="{ selectHide: !open }">

          <div v-if="options.length > 0" class="items_list">
            <div
              v-for="(option, i) of options"
              :key="i"
              @click="onClickElement(option)"
              :id="`div_${option.id}`"
            >
              <div v-if="isPoint">
                <div class="point_descs item_option">
                  <div class="point_desc_1">{{ option.district }}</div>
                  <div>
                    <div class="point_desc_row">
                      <div class="point_desc_2">{{ option.name }}</div>
                      <button
                        type="button"
                        v-if="hasOpeningHours(option)"
                        class='opening_hours_button'
                        @click.stop="openOpeningHours(option)"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 7v5.5l3.5 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
                        <span>Ver horarios</span>
                      </button>
                    </div>
                    <div class="point_desc_3">{{ option.address }}</div>
                    <div class="point_tags">
                      <PointCapacityTag :point="option" />
                      <PointOfSaleTag :point="option" />
                      <CashOnDeliveryTag :point="option" />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!isPoint" class="item_option">
                <div>
                  {{ option.text }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="options.length === 0 && textToFind">
            <div style="padding-left: 15px;">
              {{ isLoading ? 'Buscando resultados...' : 'No hay resultados.' }}
            </div>
          </div>

        </div>
      </div>
      <ErrorMessage :message="errorMessage" v-if="notSelectedBeforeBlur && isRequired"/>
      <OpeningHoursModal
        :visible="!!openingHoursPoint"
        :point="openingHoursPoint"
        @close="openingHoursPoint = null"
      />
    </div>
  </div>
</template>

<script>
import ErrorMessage from '../ErrorMessage.vue'
import RingLoader from '../Loaders/RingLoader.vue'
import OpeningHoursModal from '@/components/Shared/OpeningHoursModal.vue'
import { hasOpeningHours } from '@/utils/openingHours'
import PointCapacityTag from '@/components/Shared/PointCapacityTag.vue'
import PointOfSaleTag from '@/components/Shared/PointOfSaleTag.vue'
import CashOnDeliveryTag from '@/components/Shared/CashOnDeliveryTag.vue'

// esto es para que se ejecute una funcion luego de un tiempo establecido
function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      timeout = null
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export default {
  props: {
    value: {
      // type: Number,
      required: true
    },
    repoSearch: {
      type: Function,
      required: true,
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: 'Ingrese valor'
    },
    isPoint: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: "Error"
    },
    showEmptyInputError: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    },
  },
  components: {
    ErrorMessage,
    RingLoader,
    PointCapacityTag,
    PointOfSaleTag,
    CashOnDeliveryTag,
    OpeningHoursModal,
  },
  data() {
    return {
      selected: null,
      open: false,
      textToFind: '',
      textToShow: '',
      options: [],
      isClickedInside: false,
      notSelectedBeforeBlur: false,
      isLoading: false,

      idSelectedFromOutside: '',
      openingHoursPoint: null
    };
  },
  methods: {
    hasOpeningHours,
    openOpeningHours(option) {
      this.openingHoursPoint = option
    },
    optionLabel(option) {
      if (!option) return ''
      return this.isPoint
        ? (option.labelAfterSelect || option.name || option.Name || '')
        : (option.text || '')
    },
    init() {
      this.selected = this.options.find(option => option.id === this.value)
      this.textToShow = this.optionLabel(this.selected)
    },
    // Unlike selectElementFromOutside, does not replay the original search: that text is not
    // always stored, and without it the field ends up blank.
    restoreSelection(option) {
      const id = option?.id
      if (id === null || id === undefined || id === '') return
      this.options = [option]
      this.selected = option
      this.notSelectedBeforeBlur = false
      this.textToShow = this.optionLabel(option)
      this.$emit('input', id)
      this.$emit('itemSelected', { ...option, textToFind: option.textToFinded || '' })
    },
    onClickElement(option) {
      setTimeout(() => {
        this.open = false
      }, 50)
      this.notSelectedBeforeBlur = false
      this.$emit('input', option.id)
      this.$emit('itemSelected', { ...option, textToFind: this.textToFind })
      this.init()
    },
    handleClickOutside(event) {
      if (this.openingHoursPoint) return
      // Para checar si se hizo click dentro o fuera de todo esto
      const clickedComponent = event.target
      const isClickedInside = this.$el.contains(clickedComponent)
      this.isClickedInside = isClickedInside
      if(this.open && !isClickedInside && !this.textToFind) {
        this.init()
      }

      if(this.open && !isClickedInside && !this.textToShow) this.notSelectedBeforeBlur = true
      if(this.open && !isClickedInside && this.textToShow) this.notSelectedBeforeBlur = false

      this.open = isClickedInside
    },
    selectElementFromOutside(option) {
      this.idSelectedFromOutside = option.id
      this.textToFind = option.textToFinded
      this.$emit('input', option.id)
    },
    reset() {
      this.textToFind = ''
      this.textToShow = ''
      this.selected = null
      this.options = []
      this.open = false
    },
  },
  created () {
    this.init()
    this.$watch('value', newValue => {
      this.selected = this.options.find(option => option.id === newValue)
      this.textToShow = this.optionLabel(this.selected)
    })
    this.$watch('open', newValue => {
      if(newValue) {
        this.$nextTick(() => {
          this.$refs.myInput.focus();
        })
      }
    })
    this.$watch('textToFind', debounce(async text => {
      this.options = []
      if(!text) {
        this.$emit('input', null)
        this.$emit('itemSelected', null)
        return
      }
      this.isLoading = true
      try {
        const data = await this.repoSearch(text)
        this.options = data
        if (this.idSelectedFromOutside) {
          setTimeout(() => {
            const div = document.querySelector(`#div_${this.idSelectedFromOutside}`)
            div.click()
            this.idSelectedFromOutside = ''
          }, 200)
        }
        this.init()
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
      // Cada 300ms hace la busqueda
    }, 300))
    this.$watch('showEmptyInputError', value => {
      if(value) {
        this.notSelectedBeforeBlur = true
      }
    })
    document.addEventListener('click', this.handleClickOutside)
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};

</script>
<style scoped>
.label__search_container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.label_input_search {
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #1A1A1A !important;
}
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
}

.custom-select .selected {
  padding: 0 16px;
  cursor: pointer;
  user-select: none;
  min-height: 50px;
  border: 1px solid #737373;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom-select .selected:hover {
  border: 1px solid #1A1A1A;
}

.custom-select .selected.open { border: 2px solid #1A1A1A }
.custom-select .selected.notSelectedBeforeBlur { border: 1px solid #E50000 }

/* .custom-select .selected:after {
  position: absolute;
  content: "";
  top: 22px;
  right: 1em;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #5f5f5f transparent transparent transparent;
} */

.custom-select-placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #737373;
}
.input_search {
  border-bottom: none !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

.custom-select .items {
  border-radius: 6px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  z-index: 99;
  max-height: 250px;
  overflow: overlay; /* para el scroll sea sobre las coasas */
  margin-top: 5px;
  line-height: 47px;
}
.item_option {
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}
.custom-select .items .items_list > div:not(:last-child) {
  border-bottom: 1px solid #DEDEDE;
}
.item_option:hover { background: rgba(0, 0, 0, 0.05) }
.item_option:active { background: rgba(0, 0, 0, 0.15) }

.point_descs {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.point_desc_1 {
  line-height: 20px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #737373;
}
.point_desc_2 {
  line-height: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #1A1A1A;
}
.point_desc_3 {
  line-height: 20px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #1A1A1A;
}


.opening_hours_button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #D0D0D0;
  border-radius: 999px;
  background: transparent;
  font-size: 12px;
  line-height: 18px;
  color: #1A1A1A;
  white-space: nowrap;
  cursor: pointer;
}

.opening_hours_button:hover { background: rgba(0, 0, 0, 0.05) }

.point_desc_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.point_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.selectHide {
  display: none;
}

.custom-select .items::-webkit-scrollbar {
  width: 15px;
}
.custom-select .items::-webkit-scrollbar-thumb {
  background: rgba(26, 26, 26, 0.5);
  background-clip: content-box;
  border: 5px solid transparent;
  border-radius: 15px;
}
</style>